(function(SU){
    // 跳入登录页面
    function gotoLogin(redirect_url) {

      var curUrl = location.href.substring( location.href.indexOf(location.hostname)+location.hostname.length) //location.pathname + location.search,
          weixinLoginUrl = '/server/account/weixin_login',
          mLoginUrl = '/user/login.html',
          logUrl = '';
      if (redirect_url) {
          curUrl = redirect_url;
      }
      if($.device.isWeixin){
        var key = Mtils.security.hex_md5(curUrl);
        store.set(key,curUrl);
        logUrl = weixinLoginUrl + '?redirect_url=' + key;
      }else{
        logUrl = mLoginUrl + '?redirect_url=' + encodeURIComponent(curUrl);
      }
      let hostname = location.host.indexOf(":")>0?'front.h5.sosho.cn':location.hostname
      window.location.href = location.protocol + '//' + hostname + logUrl 
    }
  
    sosho.gotoLogin = gotoLogin;

    SU.gotoRedirectUrl = function() {
        var redirectUrl = decodeURIComponent(sosho.utils.redirectUrl());
        if (redirectUrl === 'undefined') {
            window.location.href = '/index.html';
        } else {
            window.location.href = location.protocol + '//' + location.hostname + redirectUrl;
        }
    };

		// 普通浏览器图片上传组件
		SU.imgUpload = function(config) {
			$.ajax({
				url: '/api/tool/upload_token',
				data: {
					bucket: config.bucket
				},
				success: function(dataIn) {
					if (dataIn.errno === 0) {
						var data = dataIn.data;
						var Qiniu2 = new QiniuJsSDK();
	
						if (typeof config.maxFileSize === 'undefined') {
							config.maxFileSize = 10;
						}
	
						if (typeof config.maxNum === 'undefined') {
							config.maxNum = 6;
						}
	
						var uploader2 = Qiniu2.uploader({
							runtimes: 'html5,flash,html4', // 上传模式,依次退化
							browse_button: config.browse_button, // 上传选择的点选按钮，**必需**
							uptoken: data.qiniu_token, // uptoken 是上传凭证，由其他程序生成
							get_new_uptoken: false, // 设置上传文件的时候是否每次都重新获取新的 uptoken
							domain: data.domain, // bucket 域名，下载资源时用到，**必需**
							container: config.container, // 上传区域 DOM ID，默认是 browser_button 的父元素，
							max_file_size: config.maxFileSize + 'mb', // 最大文件体积限制
							flash_swf_url: 'http://cdn.staticfile.org/Plupload/2.1.1/Moxie.swf', //引入 flash,相对路径
							max_retries: 3, // 上传失败最大重试次数
							auto_start: true, // 选择文件后自动上传，若关闭需要自己绑定事件触发上传,
							unique_names: true,
							save_key: false,
							filters: {
								mime_types: [ //只允许上传图片
									{
										title: "Image files",
										extensions: "jpg,jpeg,png,gif"
									}
								],
								prevent_duplicates: false //不允许选取重复文件
							},
							resize: {
								width: config.width,
								height: config.height,
								crop: true,
								quality: 70,
								preserve_headers: true
							},
							init: {
								'FilesAdded': function(up, files) {
									var maxNum = config.maxNum;
									if (files.length > maxNum) {
										alert('每次只能上传' + maxNum + '张照片');
									}
									plupload.each(files, function(file, index) {
										// 文件添加进队列后,处理相关的事情
										if (file.origSize > config.maxFileSize * 1024 * 1024) {
											uploader2.removeFile(file);
											$.alert('照片大小不能超过'+config.maxFileSize+'M');
										}
										if (index > maxNum - 1) {
											uploader2.removeFile(file);
										}
									});
	
								},
								'BeforeUpload': function(up, file) {
	
									$.showIndicator();
									if (typeof config.beforeUpload !== 'undefined') {
										config.beforeUpload(up, file);
									}
								},
								'UploadProgress': function(up, file) {
									if (typeof config.uploadProgress !== 'undefined') {
										config.uploadProgress(up, file);
									}
								},
								'FileUploaded': function(up, file, info) {
									config.uploaded(up, file, info);
									config.errTip = ''
								},
								'Error': function(up, err, errTip) {
									if (err.code === -600) {
										$.alert('图片大小不能超过' + config.maxFileSize + 'M');
										return;
									}
									if(err.code === -602){
										$.alert('请勿重复上传同一图片');
										return;
									}
									if (typeof config.error !== 'undefined') {
										config.error(up, err, errTip);
									}
									if(errTip.indexOf('is forbidden to upload') >= 0){
										config.errTip = errTip;
										setTimeout(function(){
											if(config.errTip){
												SU.alert('上传文件类型错误，请重新上传');
											}										
										},300)									
									}								
								},
								'UploadComplete': function() {
									//队列文件处理完毕后,处理相关的事情
									$.hideIndicator();
									if (typeof config.uploadComplete !== 'undefined') {
										config.uploadComplete(up, file, info);
									}
								}
							}
						});
					}
				}
			});
		};
    
    // 图片上传组件
	// obj.button_id 上传按钮id
	// obj.container_id 按钮容器id
	// obj.success 上传成功的回调
	// obj.params 给回调传的入参
	// obj.count 每次上传的图片数量，最大不能超过9
	sosho.initImgUpload = function(obj) {
		
		var platform = SU.store.get('platform'),
			doc = $(document);
		if (typeof obj.params === 'undefined') {
			obj.params = {};
		}

		if(typeof obj.count === 'undefined'){
			obj.count = 1;
		}else if(obj.count < 1){
			$.alert('每次上传的图片数不能小于1');
			return;
		}else if(obj.count > 9){
			$.alert('每次上传的图片数不能大于9');
			return;
		}

		// 如果是 android  app 则调用 app 上传组件
		if (platform === 'android') {
			
			window.imgUploadCancel = function() {
				$.hideIndicator();
			};
			$(obj.button_id).on('click', function(event) {
				event.preventDefault();
				$.showIndicator();
				if(obj.count === 1){
					window.webSignUp.toChoosePic(true);
				}else{
					window.webSignUp.toChoosePic(false);
				}

				window.imgUploadSuccess = function(url) {
					obj.params.imgsrc = url;
					obj.success(obj.params);
					$.hideIndicator();
				};

			});
		} else {
			// 非微信环境，调用系统上传组件
			if (!$.device.isWeixin) {
				SU.imgUpload({
					bucket: 'pics',
					browse_button: obj.button_id.split('#')[1],
					container: obj.container_id.split('#')[1],
					maxFileSize: 10,
					maxNum: obj.count,
					width: '',
					height: '',
					uploaded: function(up, file, info) {
						var domain = up.getOption('domain'),
							res = JSON.parse(info);
						obj.params.imgsrc = domain + '/' + res.key;
						obj.success(obj.params);
					}
				});
			}
			//微信环境调用微信上传组件
			else {
				$(obj.button_id).on('click', function(event) {
					event.preventDefault();
					wx.chooseImage({
						count: obj.count,
						//sizeType: ['compressed'],
						success: function(res) {
							// console.log(111,res);
							var localIds = res.localIds,
								i = 0,
								length = localIds.length;

							function fail(msg) {
								var count = i+1;

								$.alert('第' + count + '张图片上传失败，照片大小不能超过10M', function() {
									i++;
									if (i < length) {
										upload();
									}
								});
							}


							function upload() {
								wx.uploadImage({
									localId: localIds[i],
									success: function(res) {
										// console.log(22,res);
										// 拉取图片到sosho服务器
										$.ajax({
											url: '/tool/upload_weixin_pic',
											type: 'GET',
											data: {
												media_id: res.serverId
											},
											success: function(data) {
												if (data.errno === 0) {
													obj.params.imgsrc = data.data.result.img_path;
													obj.success(obj.params);
													i++;
													if (i < length) {
														upload();
													}
												} else {
													fail();
												}
											}
										});
									},
									fail: function(res) {
										$.alert(JSON.stringify(res))

										fail();
									}
								});
							}

							upload();
                        },
                        fail: function(res) {
                            $.alert(JSON.stringify(res));
                        }
					});
				});
			}
		}
	};

	// mock 请求 url 的 ajax
	$.ajax = function(option){
		var options = {};
		$.map(option,function(value,key){
		  options[key] = value;
		});
	
		var url = '/server' + options.url,
			forDevDataHost = store.get('data_dev_host'),
			token = SU.store.get('token'),
			uid = SU.store.get('uid'),
			openid = SU.store.get('openid'),
			appid = SU.store.get('appid'),
			expire_timestamp = SU.store.get('expire_timestamp'),
			sign_type = SU.store.get('sign_type', 'md5v2.0');
	
		if(typeof forDevDataHost !== 'undefined'){
		  url = forDevDataHost + url;
		}else if(location.hostname === 'front.h5.sosho.cn'){
		  url = '//test.h5.sosho.cn' + url;
		}
	
		// console.log(location.hostname);
		//server/api开头的url直接访问原始api
		if(/^\/api\//.test(option.url)){
		  if(!options.headers) options.headers={};
		  options.headers['appkey'] = 'h5';
		  var dataUrl=options.url.replace(/^\/api/,'',-1);
		  var devApiHost = store.get('data_dev_api_host');
		  var api_env = Cookies.get('api_env');
		  if(dataUrl === '/server/account/send_scode') {
			url = '//xy-h5.ahjzu.edu.cn'+dataUrl;
		  } else if(dataUrl.indexOf('/npc')==0||dataUrl.indexOf('/senior')==0){
			url = '//xy-api.ahjzu.edu.cn'+dataUrl;//正式
		  }else if(api_env == 'pro'){
			url = '//xy-api.ahjzu.edu.cn'+dataUrl;//正式
		  }else if(api_env == 'local'){
			url = '//localhost:3000'+dataUrl;//本地环境
		  }else if(api_env == 'test'||location.host.indexOf(':')>0){
			url = '//test.api.sosho.cn'+dataUrl;//测试
		  }else if(typeof devApiHost !== 'undefined'){
			console.log('使用自定义originalApiHost:'+devApiHost);
			url=devApiHost+dataUrl;//自定义
		  }else if(location.hostname === 'h5.sosho.cn'){
			url = '//xy-api.ahjzu.edu.cn'+dataUrl;//正式
		  }else if(location.hostname === 'test.h5.sosho.cn'){
			url = '//test.api.sosho.cn'+dataUrl;//测试
		  }else if(location.hostname === 'front.h5.sosho.cn'){
			url = '//test.api.sosho.cn'+dataUrl;//?
		  }else if(location.hostname === 'local.h5.sosho.cn'){
			url = '//localhost:3000'+dataUrl;//本地环境
		  }else if(location.hostname === 'staging.h5.sosho.cn'){
			url = '//staging-api.sosho.cn'+dataUrl;//预发布
		  }else if(location.hostname === 'm.sosho.cn'){
			url = '//staging-api.sosho.cn'+dataUrl;//预发布
		  }else if(location.hostname === 'pro.h5.sosho.cn'){
			url = '//staging.h5.sosho.cn:3000'+dataUrl;//预发布
		  }else{
			url = '//xy-api.ahjzu.edu.cn'+dataUrl;//本地环境
		  }
		}
	
		options.url = url;
	
		// 如果有登录信息 则写入请求头
		if(sosho.isLogin()&&option.url.indexOf('/api/npc')!=0&&option.url.indexOf('/api/senior')!=0){
		  if(!options.headers){
			options.headers = {};
		  }
		  options.headers['token'] = token;
		  options.headers['uid'] = uid;
		  options.headers['expire'] = expire_timestamp;
	
		  if(appid && appid > 10){
	
			options.headers['appid'] = appid;
	
		  }
		}
	
		// 如果有openid 则header里面传入openid
		if(openid && openid.length > 10){
		  if(!options.headers){
			options.headers = {};
		  }
		  options.headers['openid'] = openid;
		}
	
		var callback = options.success;
		options.success = function(data, status, xhr){
		  if(data.errno === 1001){ // 未登录或者登录过期
	
			SU.store.remove('token');
			SU.store.remove('uid');
			SU.store.remove('expire_timestamp');
			SU.store.remove('openid');
			SU.store.remove('appid');
	
			// sosho.gotoLogin();
		  }else if(data.errno === 1002){ //如果没有授权则重新授权
	
			SU.store.remove('token');
			SU.store.remove('uid');
			SU.store.remove('expire_timestamp');
			SU.store.remove('openid');
			SU.store.remove('appid');
			sosho.gotoLogin();
		  }else if(data.errno === 404){
			//SU.jumpTo('/error/404.html');
		  }else if(data.errno === 403){
			SU.jumpTo('/error/403.html');
		  }else if(data.errno === 500){
			SU.jumpTo('/error/500.html');
		  }else if(options.type !== 'POST' && data.errno !== 0){
			SU.alert(data.errmsg);
		  }
	
		  return callback(data, status, xhr);
	
		};
		return $._ajax(options);
	  };
    // sosho.isLogin = function(){
    //   var token = SU.store.get('token'),
    //       uid = SU.store.get('uid'),
    //       expire_timestamp = SU.store.get('expire_timestamp');
      
    //   return (!!token && !!uid && !!expire_timestamp);
  
    // };
  
    // // 微信静默登录授权
    // SU.silent = {
    //   isLogin: function(){
    //     var openid = SU.store.get('openid'),
    //         flag = false;
  
    //     if(openid && openid.length>10){
    //       flag = true;
    //     }
  
    //     if(sosho.isLogin()){
    //       flag = true;
    //     }
    //     return flag;
    //   },
    //   gotoLogin: function(){
    //     var current = location.pathname + location.search;
    //     var key = Mtils.security.hex_md5(current);
    //     store.set(key,current);
    //     jumpTo('/server/account_v2/weixin_login?userInfo=1&auth=1&redirect_url=' + key);
    //   }
    // };
  
    // // 给 class .go-to-login 绑定 gotoLogin
    // $(function(){
    //   $(document).on('click','.go-to-login',function(e){
    //     e.preventDefault();
    //     gotoLogin();
    //   });
    // });
  
    // SU.gotoJoinCom = function(com_id,next_url){
    //   var join_url = '/community/verification.html?com_id=' + com_id;
    //   if($.device.isWeixin){
    //     join_url = '/community/join.html?com_id=' + com_id;
    //   }
    //   if(next_url){
    //     join_url = join_url +'&next_url=' + LZString.encodeURIComponent(next_url);
    //   }
    //   jumpTo(join_url);
    // };
  })(sosho.utils);
  


//////////////////
// WEBPACK FOOTER
// ./static/js/util.js
// module id = VqYF
// module chunks = 118